// This program has been developed by students from the bachelor Computer Science
// at Utrecht University within the Software Project course. Copyright (c) Utrecht
// University (Department of Information and Computing Sciences)

import { userAPI } from "@/utils/apiCalls";
import { store } from "@/store";

interface Avatar {
  avatarId: number;
  src: string;
}

/**
 * Find the avatar with the correct avatar id in the list of avatars. If there is not avatar with the corresponding avatar id, the first
 * avatar in the list is returned.
 * @param avatarId the id of the avatar
 * @returns Avatar
 */
const getAvatar = (avatarId: number | undefined): Avatar => {
  const avatar = avatars.find((avatar: Avatar) => avatar.avatarId === avatarId);
  return avatar ?? avatars[0];
};

/**
 * Get the current avatar
 * @returns Current avatar
 */
const currentAvatar = (): Avatar => {
  return getAvatar(store.getters.getUserInfo?.avatarId);
};

//Save avatar
const saveAvatar = (avatar: Avatar): void => {
  userAPI.setAvatarId(avatar.avatarId);
};

//List of avatars
const avatars: Avatar[] = [
  {
    avatarId: 1,
    src: require("@/assets/images/avatars/Barn.png"),
  },
  {
    avatarId: 2,
    src: require("@/assets/images/avatars/Hay.png"),
  },
  {
    avatarId: 3,
    src: require("@/assets/images/avatars/Tractor.png"),
  },
  {
    avatarId: 4,
    src: require("@/assets/images/avatars/Tree.png"),
  },
];

export { Avatar, getAvatar, currentAvatar, saveAvatar, avatars };
